var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDownload = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.4928C10.3452 2.4928 10.625 2.77262 10.625 3.1178V12.8589L14.5581 8.92586C14.8021 8.68178 15.1979 8.68178 15.4419 8.92586C15.686 9.16993 15.686 9.56566 15.4419 9.80974L10 15.2517L4.55806 9.80974C4.31398 9.56566 4.31398 9.16993 4.55806 8.92586C4.80214 8.68178 5.19786 8.68178 5.44194 8.92586L9.375 12.8589V3.1178C9.375 2.77262 9.65482 2.4928 10 2.4928Z",
    fill: "#008D72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16.2428V17.4928H17.5V16.2428H2.5Z",
    fill: "#008D72"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDownload);
export default ForwardRef;